import { CarbonTrack } from '@core/domain/model/sustainability/carbon-track.model';
import { CarbonTrackFilters } from '@pages/sustainability/ui/carbon-track/models/carbon-track-filters.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { OriginWarranty, OriginWarrantyFilters } from '@core/domain/model/sustainability/origin-warranty.model';

export const sustainabilityActions = createActionGroup({
  source: 'Sustainability',
  events: {
    fetchCarbonTrack: emptyProps(),
    setCarbonTrackError: props<{ error: string }>(),
    setCarbonTrackFilters: props<{ filters: CarbonTrackFilters }>(),
    setCarbonTrackData: props<{ data: CarbonTrack }>(),
    downloadCarbonTrackPdf: emptyProps(),

    fetchOriginWarranty: emptyProps(),
    setOriginWarrantyError: props<{ error: string }>(),
    setOriginWarrantyFilters: props<{ filters: OriginWarrantyFilters }>(),
    setOriginWarrantyData: props<{ data: OriginWarranty }>(),
    downloadOriginWarrantyPdf: emptyProps(),

    // SUSTAINABILITY-SUMMARY
    fetchSummaryCarbonTrack: emptyProps(),
    setSummaryCarbonTrackFilters: props<{ filters: CarbonTrackFilters }>(),
    setSummaryCarbonTrackData: props<{ data: CarbonTrack | null }>(),
  },
});
